import { api } from '@/shared/config/axiosConfig';
import { buildEndpoint } from '@/shared/utils/buildEndpoint';
import { userFromDto } from '../mappers/usersMapper';

const BASE_ENDPOINT = 'users';

const buildServiceEndpoint = ({ id, action } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id, action });
}

export const getUsers = async () => {
  const endpoint = buildServiceEndpoint();
  const response = await api.get(endpoint);
  return response.data.map(userFromDto);
};